import React from 'react';

const EmployeeDetailModal = ({ employee, isOpen, onClose }) => {
  if (!isOpen || !employee) return null;

  return (
    <>
      {/* Modal Backdrop */}
      <div 
        className="modal-backdrop fade show" 
        style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          backgroundColor: 'rgba(0,0,0,0.5)', 
          zIndex: 1050 
        }}
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div 
        className="modal fade show" 
        style={{ 
          display: 'block', 
          position: 'fixed', 
          top: '50%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)', 
          zIndex: 1060 
        }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title">Çalışan Detayları</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="row">
                {/* Profile Photo */}
                <div className="col-md-4 text-center mb-4">
                  <img 
                    src={employee.avatar} 
                    alt={employee.name} 
                    className="rounded-circle mb-3" 
                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                  />
                  <h4>{employee.name}</h4>
                  <p className="text-primary">{employee.title}</p>
                  <span className="badge bg-light text-dark">{employee.department}</span>
                </div>

                {/* Details */}
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-6 mb-3">
                      <strong>E-posta:</strong><br/>
                      <a href={`mailto:${employee.email}`} className="text-decoration-none">
                        {employee.email}
                      </a>
                    </div>
                    <div className="col-6 mb-3">
                      <strong>Telefon:</strong><br/>
                      <a href={`tel:${employee.phone}`} className="text-decoration-none">
                        {employee.phone}
                      </a>
                    </div>
                    <div className="col-6 mb-3">
                      <strong>Lokasyon:</strong><br/>
                      {employee.location}
                    </div>
                    <div className="col-6 mb-3">
                      <strong>Departman:</strong><br/>
                      {employee.department}
                    </div>
                    <div className="col-6 mb-3">
                      <strong>Unvan:</strong><br/>
                      {employee.title}
                    </div>
                    <div className="col-6 mb-3">
                      <strong>Çalışma Yılı:</strong><br/>
                      {Math.floor(Math.random() * 10) + 1} yıl
                    </div>
                  </div>

                  {/* Additional Info */}
                  <hr />
                  <div className="row">
                    <div className="col-12 mb-3">
                      <strong>Uzmanlık Alanları:</strong><br/>
                      <div className="mt-2">
                        <span className="badge bg-primary me-2">Proje Yönetimi</span>
                        <span className="badge bg-success me-2">İnşaat Mühendisliği</span>
                        <span className="badge bg-info">Liderlik</span>
                      </div>
                    </div>
                    <div className="col-12">
                      <strong>Son Projeler:</strong><br/>
                      <ul className="list-unstyled mt-2">
                        <li><i className="bx bx-check text-success me-2"></i>Ankara-İstanbul YHT Projesi</li>
                        <li><i className="bx bx-check text-success me-2"></i>İzmir Metro Genişletmesi</li>
                        <li><i className="bx bx-time text-warning me-2"></i>Bakü Havalimanı Terminali (Devam ediyor)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-primary"
                onClick={() => {
                  window.location.href = `mailto:${employee.email}`;
                }}
              >
                <i className="bx bx-envelope me-1"></i>
                E-posta Gönder
              </button>
              <button 
                type="button" 
                className="btn btn-outline-primary"
                onClick={() => {
                  navigator.clipboard.writeText(employee.phone);
                  alert('Telefon numarası kopyalandı!');
                }}
              >
                <i className="bx bx-phone me-1"></i>
                Ara
              </button>
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onClose}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeDetailModal; 